module.exports = __webpack_public_path__ + "img/symbol_1.ee6c2796.png";